import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';

type Program = {
    value: string;
    label: string;
    display_color?: string;
};

type LoadProgramsParams = {
    userId: number | string;
    country: string;
};

export const loadPrograms = createAsyncThunk(
    'api/programs/load',
    async ({ userId, country }: LoadProgramsParams, { rejectWithValue }) => {
        try {
            const userIdNumber = typeof userId === 'string' ? Number(userId) : userId;
            const cacheKey = `${userIdNumber}:${country}`;

            const resp = await api.programList.get(userIdNumber, country);

            if (resp?.status === 200 || resp?.status === 201) {
                const data = resp?.data;
                let programs: Program[] = [];

                if (Array.isArray(data) && data.length > 0) {
                    // Check if it's the new enhanced format (objects with program_name)
                    if (typeof data[0] === 'object' && data[0].program_name) {
                        programs = data.map(
                            (e: { program_name: string; display_color?: string }) => ({
                                value: e.program_name,
                                label: e.program_name,
                                display_color: e.display_color,
                            })
                        );
                    } else {
                        // Old format (strings) - convert to new format for consistency
                        programs = data.map((program: string) => ({
                            value: program,
                            label: program,
                            display_color: 'black',
                        }));
                    }
                }

                return { programs, cacheKey };
            }

            return { programs: [], cacheKey };
        } catch (error) {
            console.error('Failed to load programs:', error);
            return rejectWithValue('Failed to load programs');
        }
    }
);
